import styled from "styled-components";

export const Row = styled.div`
    display: flex;
    align-items: flex-end;
    gap: 8px;
    margin: 6px 0;
    justify-content: ${(props) => (props.$me ? "flex-end" : "flex-start")};
`;

export const Avatar = styled.div`
    width: 32px;
    height: 32px;
    border-radius: 50%;
    flex: 0 0 auto;
    background: ${(props) => props.$color || "#2BC0AD"};
    color: #FFFFFF;
    font-size: 0.7rem;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const Bubble = styled.div`
    position: relative;
    max-width: 68%;
    padding: 8px 26px 8px 12px;
    border-radius: 12px;
    background: ${(props) => (props.$me ? "#2F80ED" : "#F1F4F9")};
    color: ${(props) => (props.$me ? "#FFFFFF" : "#2B3240")};
    font-family: Mulish;
`;

export const Sender = styled.div`
    font-size: 0.75rem;
    font-weight: 800;
    color: #2F80ED;
    margin-bottom: 2px;
`;

export const Content = styled.div`
    font-size: 0.86rem;
    line-height: 1.35;
    white-space: pre-wrap;
    word-break: break-word;
`;

export const Time = styled.div`
    font-size: 0.66rem;
    margin-top: 3px;
    text-align: right;
    color: ${(props) => (props.$me ? "rgba(255,255,255,0.8)" : "#8A94A6")};
`;

export const MenuTrigger = styled.button`
    position: absolute;
    top: 4px;
    right: 4px;
    border: none;
    background: transparent;
    padding: 0;
    cursor: pointer;
    display: inline-flex;
    font-size: 1rem;
    line-height: 1;
    color: ${(props) => (props.$me ? "rgba(255,255,255,0.85)" : "#8A94A6")};
`;

export const MediaImg = styled.img`
    max-width: 240px; max-height: 240px; border-radius: 10px; cursor: pointer; display: block; object-fit: cover;
`;

export const MediaVideo = styled.video`
    max-width: 260px; max-height: 260px; border-radius: 10px; display: block;
`;

export const DocCard = styled.a`
    display: inline-flex; align-items: center; gap: 8px; text-decoration: none;
    background: #F4F8FE; border: 1px solid #DCE6F7; border-radius: 10px; padding: 10px 12px;
    color: #2F80ED; font-size: 0.85rem; font-weight: 600; max-width: 240px;
    span { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
`;

export const MediaUnavailable = styled.div`
    font-size: 0.8rem; color: #9A6B12; background: #FFF7E6; border-radius: 8px; padding: 8px 10px;
`;

export const MediaSticker = styled.img`
    width: 130px; height: 130px; object-fit: contain; display: block;
`;

export const ReactionRow = styled.div`
    display: flex; gap: 4px; margin-top: 4px; flex-wrap: wrap;
`;

export const ReactionChip = styled.span`
    display: inline-flex; align-items: center; gap: 3px; background: #FFFFFF; border: 1px solid #E2E8F0;
    border-radius: 12px; padding: 1px 7px; font-size: 0.78rem; color: #4B5563; line-height: 1.6;
`;
